export default "__VITE_ASSET__32d08fef__"